let activeAnimationFrame = null;

const easeInOutCubic = (t) =>
  t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;

const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia &&
  window.matchMedia("(prefers-reduced-motion: reduce)").matches;

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

export const getMenuOffset = (menuId = "menu", extraOffset = 0) => {
  if (typeof document === "undefined") return extraOffset;
  const menu = document.getElementById(menuId);
  return (menu ? menu.offsetHeight : 0) + extraOffset;
};

export const smoothScrollToPosition = (targetY, duration) => {
  if (typeof window === "undefined") return;

  const startY = window.pageYOffset;
  const distance = targetY - startY;

  if (Math.abs(distance) < 2) return;

  if (activeAnimationFrame) {
    window.cancelAnimationFrame(activeAnimationFrame);
    activeAnimationFrame = null;
  }

  if (prefersReducedMotion()) {
    window.scrollTo(0, targetY);
    return;
  }

  const totalDuration =
    duration || clamp(620 + Math.abs(distance) * 0.16, 760, 1400);
  const startTime = performance.now();

  const step = (now) => {
    const elapsed = now - startTime;
    const progress = clamp(elapsed / totalDuration, 0, 1);
    const eased = easeInOutCubic(progress);

    window.scrollTo(0, startY + distance * eased);

    if (progress < 1) {
      activeAnimationFrame = window.requestAnimationFrame(step);
    } else {
      activeAnimationFrame = null;
    }
  };

  activeAnimationFrame = window.requestAnimationFrame(step);
};

export const smoothScrollToElement = (
  target,
  { menuId = "menu", extraOffset = 0, duration } = {}
) => {
  if (typeof document === "undefined") return;

  const element =
    typeof target === "string" ? document.getElementById(target) : target;

  if (!element) return;

  const y =
    element.getBoundingClientRect().top +
    window.pageYOffset -
    getMenuOffset(menuId, extraOffset);

  smoothScrollToPosition(y, duration);
};
